import _ from 'lodash'

export const environment = (env) => {
  return process.env.NODE_ENV === env
}

let valueMapper = item => _.isFunction(item) ? item() : item

export const config = _.mapValues({
  PUSHER_KEY () {
    if (environment('development')) {
       // return 'eea65a0bdc6789ef9522'
      return 'baa25a9fa9c215bd28ea'
    } else if (environment('staging')) {
      return '7b4cd4b71ba0f094dfd8'
    }

    return '99acab1fe81419146285'
  },

  PUSHER_CONFIG () {
    if (environment('development')) {
      return {}
    }
  }
}, valueMapper)



// WEBPACK FOOTER //
// ./src/config.js